import { combineReducers } from "redux-loop";
import taskReducer from "./taskReducer";

export default combineReducers({
  tasks: taskReducer,
});
